/* ==========================================================================
   BRAVIK — Size Guide tabs + size recommender
   Three product categories: basics, polo, chemise.
   Each has its own height/weight → size mapping.
   Loaded globally, but only activates on pages that render the modal.
   ========================================================================== */
(function () {
  'use strict';

  var NEXT_SIZE = { S: 'M', M: 'L', L: 'XL', XL: null };

  /* Height/weight → size tables per product type.
     Each entry: [minHeight, maxHeight, minWeight, maxWeight, size] */
  var CHARTS = {
    basics: [
      [160, 168, 50, 60, 'S'],
      [165, 173, 58, 68, 'M'],
      [168, 178, 66, 77, 'L'],
      [172, 185, 75, 88, 'XL']
    ],
    polo: [
      [160, 168, 52, 62, 'S'],
      [165, 175, 60, 70, 'M'],
      [170, 180, 68, 80, 'L'],
      [175, 188, 78, 92, 'XL']
    ],
    chemise: [
      [160, 168, 52, 62, 'S'],
      [165, 175, 60, 70, 'M'],
      [170, 180, 68, 80, 'L'],
      [175, 188, 78, 92, 'XL']
    ]
  };

  /* Find the best-matching size for a given product type, height, and weight.
     Always returns a size — if measurements are outside all ranges,
     the closest row (by distance) wins. */
  function findSize(productType, height, weight) {
    var chart = CHARTS[productType] || CHARTS.basics;
    var best = null;
    var bestScore = -1;
    var bestRange = Infinity;
    var bestDist = Infinity;
    var TOLERANCE = 8;

    for (var i = 0; i < chart.length; i++) {
      var row = chart[i];
      var hIn = height >= row[0] && height <= row[1];
      var wIn = weight >= row[2] && weight <= row[3];
      var hNear = height >= row[0] - TOLERANCE && height <= row[1] + TOLERANCE;
      var wNear = weight >= row[2] - TOLERANCE && weight <= row[3] + TOLERANCE;

      var inOrNear = (hIn && wNear) || (wIn && hNear);

      /* Distance to this row's range center (for fallback when nothing matches) */
      var hCenter = (row[0] + row[1]) / 2;
      var wCenter = (row[2] + row[3]) / 2;
      var dist = Math.sqrt(Math.pow(height - hCenter, 2) + Math.pow(weight - wCenter, 2));

      if (inOrNear) {
        var score = (hIn ? 2 : 0) + (wIn ? 2 : 0) + (hNear && !hIn ? 1 : 0) + (wNear && !wIn ? 1 : 0);
        if (score > bestScore || (score === bestScore && (row[1]-row[0])+(row[3]-row[2]) < bestRange)) {
          bestScore = score;
          best = row[4];
          bestRange = (row[1]-row[0])+(row[3]-row[2]);
          bestDist = dist;
        }
      } else if (best === null || (bestScore === -1 && dist < bestDist)) {
        /* Track closest row as fallback (only when no in-range match yet) */
        bestDist = dist;
        best = row[4];
        bestScore = -1; /* marker: this is a fallback */
      }
    }

    return best;
  }

  /* Check if a size is a fallback (outside standard range) */
  function isFallbackSize(productType, height, weight) {
    var chart = CHARTS[productType] || CHARTS.basics;
    var TOLERANCE = 8;
    for (var i = 0; i < chart.length; i++) {
      var row = chart[i];
      var hIn = height >= row[0] && height <= row[1];
      var wIn = weight >= row[2] && weight <= row[3];
      var hNear = height >= row[0] - TOLERANCE && height <= row[1] + TOLERANCE;
      var wNear = weight >= row[2] - TOLERANCE && weight <= row[3] + TOLERANCE;
      if ((hIn && wNear) || (wIn && hNear)) return false;
    }
    return true;
  }

  function whatsappBase(node) {
    return (node.getAttribute('href') || 'https://wa.me/201559345325').split('?')[0];
  }

  function initSizeGuideExtras() {
    var modal = document.querySelector('.size-guide-modal');
    if (!modal || modal.dataset.recommenderReady) return;
    modal.dataset.recommenderReady = 'true';

    /* ---- EVENT DELEGATION: single listener on modal for all clicks ---- */
    modal.addEventListener('click', function (e) {
      /* Tab click (SIZE CHART / SIZE RECOMMENDATION) */
      var tab = e.target.closest('[data-sg-tab]');
      if (tab) {
        var target = tab.getAttribute('data-sg-tab');
        var tabs = modal.querySelectorAll('[data-sg-tab]');
        var panels = modal.querySelectorAll('[data-sg-panel]');
        tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-sg-panel') === target);
        });
        return;
      }

      /* Pill click (BASICS / POLOS / CHEMISE) */
      var pill = e.target.closest('[data-sg-product]');
      if (pill) {
        var pTarget = pill.getAttribute('data-sg-product');
        var pills = modal.querySelectorAll('[data-sg-product]');
        var pPanels = modal.querySelectorAll('[data-sg-product-panel]');
        pills.forEach(function (p) {
          var active = p === pill;
          p.classList.toggle('is-active', active);
          p.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        pPanels.forEach(function (pp) {
          pp.classList.toggle('is-active', pp.getAttribute('data-sg-product-panel') === pTarget);
        });
        return;
      }
    });

    /* ---- Recommender ---- */
    var form = modal.querySelector('[data-sg-recommend-form]');
    if (!form) return;

    var result = modal.querySelector('[data-sg-result]');
    var resultTitle = modal.querySelector('[data-sg-result-title]');
    var resultSize = modal.querySelector('[data-sg-result-size]');
    var resultNote = modal.querySelector('[data-sg-result-note]');
    var waBtn = modal.querySelector('[data-sg-wa]');

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var height = parseFloat(form.querySelector('[data-sg-height]').value, 10);
      var weight = parseFloat(form.querySelector('[data-sg-weight]').value, 10);
      var fit = form.querySelector('[data-sg-fit]').value;
      var productType = (form.querySelector('[data-sg-product-type]') || {}).value || 'basics';

      if (!isFinite(weight) || weight <= 0 || !isFinite(height) || height <= 0) return;

      var base = findSize(productType, height, weight);
      var size, note, isFallback = false;
      var productLabel = { basics: 'Basics', polo: 'Polos', chemise: 'Chemise' }[productType] || 'Basics';

      if (!base) {
        /* Should never happen — findSize always returns a size now */
        resultTitle.textContent = 'PERSONAL FIT CHECK';
        resultSize.textContent = '—';
        note = 'Message our Cairo team on WhatsApp for a personal size recommendation.';
      } else if (isFallbackSize(productType, height, weight)) {
        size = base;
        if (fit === 'relaxed' && NEXT_SIZE[base]) size = NEXT_SIZE[base];
        note = 'Your measurements are outside our standard ' + productLabel + ' range, but ' + size + ' is the closest match. For the best fit, we recommend messaging our team on WhatsApp for a personal check.';
      } else if (fit === 'relaxed' && NEXT_SIZE[base]) {
        size = NEXT_SIZE[base];
        note = 'Sized up one step for a relaxed fit. Still unsure? Get a personal fit check.';
      } else if (fit === 'relaxed') {
        size = base;
        note = 'XL is our largest size in ' + productLabel + '. Message our Cairo team for a personal fit check.';
      } else {
        size = base;
        note = 'Based on the BRAVIK ' + productLabel + ' chart for a ' + fit + ' fit. Still unsure? Get a personal fit check.';
      }

      resultTitle.textContent = 'RECOMMENDED SIZE';
      resultSize.textContent = size || '—';
      resultNote.textContent = note;
      result.classList.add('is-visible');

      var text =
        'Hi BRAVIK, I need size advice for ' + productLabel + '. My height is: ' + height + ' cm, my weight is: ' +
        weight + ' kg, and I prefer a ' + fit + ' fit.';

      if (waBtn) {
        waBtn.setAttribute('href', whatsappBase(waBtn) + '?text=' + encodeURIComponent(text));
      }
    });
  }

  /* Run as soon as the DOM is ready — defer guarantees the DOM is parsed. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizeGuideExtras);
  } else {
    initSizeGuideExtras();
  }
})();
